module.exports = __webpack_public_path__ + "static/img/9.ee2fa08.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/8/sp/9.png
// module id = tmnM
// module chunks = 0